import BlockStyleControls from './BlockStyleControls';
import InlineStyleControls from './InlineStyleControls';

export default function DefaultToolbar(props) {
  return (
    <>
      <BlockStyleControls {...props} />
      <InlineStyleControls {...props} />
    </>
  );
}
